import React from "react";
import {connect} from "react-redux";
import {trackPromise} from 'react-promise-tracker';
import {Datepicker} from "./Datepicker";
import {Heading} from "./Heading";
import {Label} from "./tooltipLabel";
import {PersonalData} from "./personalData";
import {FileLink} from "./fileDownloadLink";
import languages from "../collections/languages"
import pdfFfiles from "../collections/pdfFiles"
import TextBlock from "./textblock";
import Modal from "./modal";
import {checkJmbgValidity , validateEmail , getAge} from "../scripts/validation"
import {sendMail , checkCode , createCalc} from "../scripts/requests";
import {setSame , setCalc} from "../redux/actions";
import {Verification} from "./verifikacija";
import {Button} from "./Button";


class Calculation extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            error : false ,
            isSame : true ,
            isConsent : false ,
            isSports : false ,
            showModal : false ,
            isVerified : false ,
            requestType : 1 ,
            lNameInsured : false ,
            fNameInsured : false ,
            lNameContractor : false ,
            fNameContractor : false ,
        };
        this.handleChangeConsent = this.handleChangeConsent.bind ( this );
        this.handleChangeSports = this.handleChangeSports.bind ( this );
        this.handleEmailSend = this.handleEmailSend.bind ( this );
        this.handleCheckCode = this.handleCheckCode.bind ( this );

    }

    componentDidMount() {
        window.scrollTo ( 0 , 0 )
    }

    handleKeyUp(e) {


        if (e.keyCode === 27) {
            this.setState ( {
                showModal : false
            } )
        }
    }

    toggleModal = () => {
        this.setState ( {
            showModal : !this.state.showModal
        } )
    };

    handleChangeConsent() {
        !this.state.isConsent ? this.setState ( { isConsent : true } ) : this.setState ( { isConsent : false } );
    }

    handleChangeSports() {
        this.state.isSports ? this.setState ( { isSports : false } ) : this.setState ( { isSports : true } );
    }

    handleInputChange(e , state) {
        this.setState ( {
            [state] : e.target.value
        } );
        if (e.target.value) {
            this.setState (
                { ["isValid" + state] : true }
            )
        }
    }

    handleFormValidation() {
        if (!this.state.isValidfNameInsured) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : "Unesite ime osiguranika!" } );
            return false
        }
        if (!this.state.isValidlNameInsured) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : "Unesite prezime osiguranika!" } );
            return false
        }
        if (!this.props.isSame && !this.state.isValidfNameContractor) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : "Unesite ime ugovarača!" } );
            return false
        }
        if (!this.props.isSame && !this.state.isValidlNameContractor) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : "Unesite prezime ugovarača!" } );
            return false
        }
        if (!this.props.isSame && !this.state.isValidjmbgContractor) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : "Unesite JMBG ugovarača!" } );
            return false
        }
        if (!this.state.isValidjmbgInsured) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : "Unesite JMBG osiguranika!" } );
            return false
        }
    }

    handleDateInputChange(e , state) {
        this.setState ( {
            [state] : e.target
        } );
    }

    handleJMBGValid(evt , party , message) {
        let person = "jmbg" + party;
        let errMsg = checkJmbgValidity ( this.state[person] , message );
        this.setState ( {
            [person] : evt.target.value
        } );
        this.setState ( {
            errorMsg : errMsg
        } );
        if (!!this.state.jmbgContractor && (getAge ( this.state.jmbgContractor )<14) && party === "Contractor") {
            this.setState ( {
                errorMsg : "Ugovarač mora biti stariji od 14 godina!",
                showModal : true,
                error: true
            } );
        }

        if (checkJmbgValidity ( this.state[person] , message )) {
            this.setState ( {
                errorMsg : message
            } );
            this.setState ( {
                error : true
            } );
            this.setState ( {
                showModal : true
            } );
        } else {
            this.setState ( {
                error : false
            } );
        }
    }

    handleEmailSend() {
        if (this.handleFormValidation () === false) {
            return
        }
        if (!!this.state.jmbgContractor && (getAge ( this.state.jmbgContractor )<14)) {
            this.setState ( {
                errorMsg : "Ugovarač mora biti stariji od 14 godina!",
                showModal : true,
                error: true
            } );
            return;
        }
        if (!validateEmail ( this.state.email )) {
            this.setState ( { errorMsg : languages[this.props.lang].messages.invalidMail } );
            this.setState ( { showModal : true } );
            return;
        }
        if (this.state.error) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : this.props.lang === "sr" ? "Matični broj nije ispravan!" : "Personal ID number is incorrect!" } )
        } else {
            trackPromise ( sendMail ( {
                "ime" : this.props.isSame ? this.state.fNameInsured.toUpperCase () : this.state.fNameContractor.toUpperCase () ,
                "prezime" : this.props.isSame ? this.state.lNameInsured.toUpperCase () : this.state.lNameContractor.toUpperCase () ,
                "email" : this.state.email ,
                "jmbg" : this.props.isSame ? this.state.jmbgInsured : this.state.jmbgContractor ,
                "consent" : this.state.isConsent ,
                "temp" : this.props.template ,
                "lang" : this.props.lang,
                "calc": ""
            } ) ).then ( result => this.setState ( { errorMsg : JSON.parse ( result ).message } )
            ).then ( () => {
                this.setState ( { showModal : true } )
            } )
        }
    }

    handleCheckCode() {
        if (!validateEmail ( this.state.email )) {
            this.setState ( { errorMsg : languages[this.props.lang].messages.invalidMail } );
            this.setState ( { showModal : true } );
            return;
        }
        if (!!this.state.jmbgContractor && (getAge ( this.state.jmbgContractor )<14)) {
            this.setState ( {
                errorMsg : "Ugovarač mora biti stariji od 14 godina!",
                showModal : true,
                error: true
            } );
            return;
        }
        if (this.state.error) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : this.props.lang === "sr" ? "Matični broj nije ispravan!" : "Personal ID number is incorrect!" } )
        } else if (!this.state.lNameInsured || !this.state.fNameInsured || !this.state.jmbgInsured) {
            this.setState ( { showModal : true } );
            this.setState ( { errorMsg : this.props.lang === "sr" ? "Popunite sve podatke!" : "Fill all data!" } )
        } else {
            trackPromise ( checkCode ( {
                "email" : this.state.email ,
                "code" : this.state.code ,
                "consent" : this.state.isConsent ,
                "lang" : this.props.lang
            } ) ).then ( response => {
                this.setState ( { errorMsg : JSON.parse ( response ).message } );
                this.setState ( { isVerified : JSON.parse ( response ).verified } )
            } ).then ( () => {
                this.setState ( { showModal : true } )
            } );
            trackPromise ( createCalc ( {
                    "temp" : this.props.template ,
                    "datefrom" : this.props.startDate ,
                    "dateto" : this.props.endDate ,
                    "contractorRegno" : this.state.jmbgContractor ,
                    "contractorName" : this.state.fNameContractor + " " + this.state.lNameContractor ,
                    "insuredRegno" : this.state.jmbgInsured ? this.state.jmbgInsured : false ,
                    "insuredName" : this.state.fNameInsured ? (this.state.fNameInsured + " " + this.state.lNameInsured) : false ,
                    "requestType" : this.state.requestType
                }
            ) ).then ( response => {
                let json = (JSON.parse ( JSON.parse ( response ).lovcen_web_response ));
                let calc = json.calc;
                let no1 = json.no1;
                this.props.setCalc (
                    {
                        calc : calc ,
                        no1 : no1
                    }
                );
            } )
        }
    }

    files() {
        let fileCollection = pdfFfiles;
        let array = [];
        for (let file in fileCollection) {
            array.push ( <FileLink
                key={fileCollection[file].name}
                link={!!fileCollection[file][this.props.grade] ? fileCollection[file][this.props.grade].link : fileCollection[file].link}
                text={!!fileCollection[file][this.props.grade] ? fileCollection[file][this.props.grade].name : fileCollection[file].name}

            /> )
        }
        return array
    }

    verified() {
        if (!this.state.isVerified) {
            return <Verification
                emailChange={(e) => {
                    this.handleInputChange ( e , "email" )
                }}
                codeChange={(e) => {
                    this.handleInputChange ( e , 'code' )
                }}
                sendMail={this.handleEmailSend}
                submitCode={this.handleCheckCode}
                pastedCode={(e) => {
                    this.handleInputChange ( e , 'code' )
                }}/>
        }
    }

    render() {

        return (
            <div className={"flex-end"}>
                <div className={"calc-body"}>
                    <Heading
                        text={"headingDates"}
                    />
                    <Datepicker
                        handleDateChangeStart={(e) => {
                            this.handleDateInputChange ( e , 'startDate' )
                        }}
                        handleDateChangeEnd={(e) => {
                            this.handleDateInputChange ( e , 'endDate' )
                        }}
                    />
                    <PersonalData
                        handleChangeContractorName={(e) => {
                            this.handleInputChange ( e , "fNameContractor" )
                        }}
                        handleChangeContractorLastname={(e) => {
                            this.handleInputChange ( e , "lNameContractor" )
                        }}
                        handleChangeContractorJmbg={(e) => {
                            this.handleInputChange ( e , "jmbgContractor" )
                        }}
                        handleJmbgContractorValidity={(e) => {
                            this.handleJMBGValid ( e , 'Contractor' , this.props.lang === "sr" ? "Matični broj ugovarača nije ispravan!" : "Contractor's personal ID number is incorrect!" )
                        }}
                        handleChangeInsuredName={(e) => {
                            this.handleInputChange ( e , "fNameInsured" )
                        }}
                        handleChangeInsuredLastname={(e) => {
                            this.handleInputChange ( e , "lNameInsured" )
                        }}
                        handleChangeInsuredJmbg={(e) => {
                            this.handleInputChange ( e , "jmbgInsured" )
                        }}
                        handleJmbgInsuredValidity={(e) => {
                            this.handleJMBGValid ( e , 'Insured' , this.props.lang === "sr" ? "Matični broj osiguranika nije ispravan!" : "Insured's personal ID number is incorrect!" )
                        }}
                        jmbg={this.state.jmbgInsured}

                    />
                    <div className={"text-box-grey"}>
                        <TextBlock
                            text={languages[this.props.lang].consent}
                            style={{whiteSpace: "pre-white"}}/>
                        <div className={"input-group checkbox-labeled"}>
                            <input key={"checkboxConsent"}
                                   type={"checkbox"}
                                   defaultChecked={this.state.isConsent}
                                   onClick={() => {
                                       this.handleChangeConsent ()
                                   }}
                                   style={{ marginLeft : "0" }}
                            />
                            <Label
                                text={"consentAgree"}
                                tooltip={false}/>
                        </div>
                    </div>
                    {this.verified ()}
                    {this.state.isVerified &&
                    <div>
                        <Button
                            text={"Plati"}
                            class={"button-regular margin-20"}
                            onClick={() => {
                                this.setState ( { requestType : 2 } , createCalc ( {
                                    "email" : this.state.email ,
                                    "consent" : this.state.isConsent ,
                                    "temp" : this.props.template ,
                                    "datefrom" : this.props.startDate ,
                                    "dateto" : this.props.endDate ,
                                    "contractorRegno" : this.state.jmbgContractor ,
                                    "contractorName" : this.state.fNameContractor + " " + this.state.lNameContractor ,
                                    "insuredRegno" : this.state.jmbgInsured ? this.state.jmbgInsured : false ,
                                    "insuredName" : this.state.fNameInsured ? (this.state.fNameInsured + " " + this.state.lNameInsured) : false ,
                                    "requestType" : this.state.requestType,
                                } ) );
                                window.location.href = 'https://prodaja.lo.co.me/putnotest/closecalc';
                            }}/>
                    </div>}
                </div>
                <div id={"sidebar"} className={"flex grow-1 column text-box-grey"}>
                    <div>
                        <h5>obračunata premija</h5>
                        <div id={"premium"} className={"text-box-white"}>
                            {!!this.props.no1 ? this.props.no1.toFixed ( 2 ) + " €" : "0.00 €"}
                        </div>
                    </div>
                    <div>
                        <h5>Dokumenti značajni za sklapanje osiguranja</h5>
                        <div className={"text-box-white flex-end column"}>
                            {this.files ()}
                        </div>
                    </div>
                </div>
                {
                    this.state.showModal ? (
                        <Modal
                            onKeyup={(e) => {
                                this.handleKeyUp ( e )
                            }}>
                            <div id={"my-modal"}>
                                <div className={"modal-window"}>
                                    <p>{this.state.errorMsg}</p>
                                    <button
                                        className="modal-close"
                                        onClick={this.toggleModal}
                                    >OK
                                    </button>
                                </div>
                            </div>
                        </Modal>
                    ) : null
                }
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
        isSame : state ? state.isSame : '' ,
        startDate : state ? state.startDate : '' ,
        endDate : state ? state.endDate : '' ,
        template : state ? state.template : '' ,
        calc : state ? state.calc : '' ,
        no1 : state ? state.no1 : '' ,
        grade : state.grade ,
    });
};
const mapDispatchToProps = (dispatch) => {
    return ({
        setSame : (params) => {
            dispatch ( setSame ( params ) );
        } ,
        setCalc : (params) => {
            dispatch ( setCalc ( params ) );
        }
    })
};
export const CalculationBody = connect ( mapStateToProps , mapDispatchToProps ) ( Calculation );
